import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AppUtils } from 'src/app/helpers/app.utils';
import { TableModel } from 'src/app/models/table.model';
import { isNullOrUndefined } from 'util';
import { ContributorPaymentLogFilterModel } from '../../models/contributor.payement.log.filter.model';
import { PagedContributorPaymentLogDetail } from '../../models/paged.contributor.payment.log.detail';
import { PaymentService } from '../../services/payment.service';

@Component({
    selector: 'app-payment-log',
    templateUrl: './payment.log.component.html',
})
export class PaymentLogComponent implements OnInit {
    subscriptions: Subscription[];
    totalRecords: number;
    tableModel: TableModel;
    pagedContributorPaymentLogDetails: PagedContributorPaymentLogDetail = new PagedContributorPaymentLogDetail();
    isModelLoaded = false;
    filterModel = new ContributorPaymentLogFilterModel();
    paymentlogFilterModel = new ContributorPaymentLogFilterModel();

    years: Array<number>;
    months: Array<string>;

    constructor(private ngxSpinnerService: NgxSpinnerService,
        private toastr: ToastrService,
        private paymentService: PaymentService) {
    }
    ngOnInit(): void {
        this.years = AppUtils.getYears(2020);

        this.tableModel = new TableModel();
        this.totalRecords = 0;
        this.subscriptions = [];
        this.initSubscribers();
        this.getContributorPaymentLogs();
    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getContributorPaymentLogs());
        this.subscriptions.push(subscription);
    }

    getYearMonthSerialized() {
        if (isNullOrUndefined(this.paymentlogFilterModel.year) || this.paymentlogFilterModel.year === '') {
            this.months.splice(0, this.months.length);
            this.paymentlogFilterModel.month = '';
        } else {
            this.months = AppUtils.getMonths(Number(this.paymentlogFilterModel.year));
        }
        this.getContributorPaymentLogs();
    }

    getContributorPaymentLogs = () => {
        this.ngxSpinnerService.show();
        this.isModelLoaded = false;
        this.ngxSpinnerService.show();
        this.paymentService.GetContributorPaymentLogs(this.paymentlogFilterModel, this.tableModel)
        .subscribe(data => {
            this.pagedContributorPaymentLogDetails = data;
            this.totalRecords = data.totalCount;
            this.pagedContributorPaymentLogDetails.items.forEach(item => {
                item.paymentDate = AppUtils.getFormattedUtcToLocalDateTime(item.createdOn);
            });
            this.isModelLoaded = true;
            this.ngxSpinnerService.hide();
        }, error => {
            this.ngxSpinnerService.hide();
            this.isModelLoaded = true;
            AppUtils.processErrorResponse(this.toastr, error);
        });
    }
}
